// Interfaces
import { IDealBrand } from "./interfaces";

const useAvailableBrands = (brands: IDealBrand[] = [], selectedBrands: IDealBrand[] = []) => {
	return brands
		?.filter((brand) => !selectedBrands.some((item) => item.make === brand.make && !item?.model))
		.map((brand) => ({ _id: brand.make, make: brand.make }));
};

export { useAvailableBrands };
